import { mountPoint } from 'utils/generic/route-manipulation';

export const SPORTSBOOK_ROUTE_WITH_CATEGORY = `${mountPoint(
  window.getPathname()
)}${'/:category/:sport?/:region?/:competition?/:game?'}`;
